import { lazy } from 'react';

const CustomerCreate = lazy(() => import('./CustomerCreate'));

export default CustomerCreate;
